module.exports = __webpack_public_path__ + "0711a3a2462420035b6ad7b19bd091b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/head-tel.png
// module id = 200
// module chunks = 28